module.exports = __webpack_public_path__ + "static/media/favicon.f4072767.ico";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/favicon.ico
// module id = 182
// module chunks = 0